import { isAllowed } from 'api/Apollo/allower';
import permissions from 'api/Apollo/permissions';

export default function isAllowedToUpdateSchemas() {
  return isAllowed(permissions.updateSchemas);
}
